import React from "react";
import { makeNavLink } from "../shared.jsx";
import { nl } from "./nl.jsx";

// Sekcja case studies. Statystyka `dt` to tekst z ręcznym łamaniem (\n → <br/>).
const noop = () => {};

export function HomeCases({
  eyebrow = "",
  headingBefore = "",
  headingHighlight = "",
  headingAfter = "",
  cta = "",
  linkLabel = "",
  items = [],
  navigate,
  reveal = true,
}) {
  const nav = navigate || noop;
  const link = makeNavLink(nav);
  const go = (r) => () => nav(r);
  const rv = reveal ? " rv" : "";
  return (
    <section className="sec" style={{ background: "#0f1012" }}>
      <div className="container">
        <div className="section-title-row">
          <div>
            <span className="section-eyebrow">{eyebrow}</span>
            <h2 className={"h2" + rv}>{nl(headingBefore)}<span className="hl hl-paint">{headingHighlight}</span>{nl(headingAfter)}</h2>
          </div>
          <button className="lc-btn lc-btn-ghost" onClick={go("/case-studies")}>
            {cta} <span className="lc-btn-arr">↗</span>
          </button>
        </div>
        <div className="cases-grid">
          {items.map((c, ci) => (
            <a key={c.slug || ci} className={"case" + rv} {...link(`/case-studies/${c.slug}`)}>
              <span className="case-brand">{c.brand}</span>
              <h3 className="case-head">{c.head}</h3>
              <dl className="case-stats">
                {(c.stats || []).map((st, i) => (
                  <div key={i}><dt>{nl(st.dt)}</dt><dd>{st.dd}</dd></div>
                ))}
              </dl>
              <span className="case-link">{linkLabel} ↗</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
